















































import ImageList from '@/component/view/ImageList.vue';
import ProfileEdit from '@/component/view/ProfileEdit.vue';
import { OverlayStateModule } from '@/store/overlay';
import { FeedModel } from '@/type/api';
import { CreateElement, VNode } from 'vue';
import { StateChanger } from 'vue-infinite-loading';
import { Component, Vue } from 'vue-property-decorator';
import { UserStateModule, FeedStateModule } from '@/store';
import { CONSTANTS } from '@/core';
import { ContentService } from '@/kuroco_api/services/ContentService';

@Component<MyPage>({
  components: {
    ImageList,
    ProfileEdit,
  },
})
export default class MyPage extends Vue {
  // FIELDS
  UserStateModule = UserStateModule;
  pageID = 1;
  totalCntStr = '...';
  totalPageCnt?: number;
  list: FeedModel.Read.Response.Feed[] = [];
  query: ContentService.getContentServiceRcmsApi1FeedsRequest = {
    myOwnList: '1',
  };
  showsProfileEdit = false;

  // MUTATIONS
  get selfUser() {
    return this.UserStateModule.selfUser;
  }
  get myAvatarSrc(): string {
    return this.UserStateModule.myImage;
  }

  // METHODS
  infiniteHandler($state: StateChanger): void {
    if (this.totalPageCnt !== undefined && this.totalPageCnt < this.pageID) {
      $state.complete();
      return;
    }
    FeedStateModule.loadPage({ ...this.query, pageId: this.pageID })
      .then(({ feed }) => {
        const { list, pageInfo } = feed;
        this.list.push(...list);
        this.totalPageCnt = pageInfo.totalPageCnt;
        this.pageID += 1;
        this.totalCntStr = `${pageInfo.totalCnt}`;
      })
      .then(() => $state.loaded())
      .catch((e) => {
        switch (e) {
          case CONSTANTS.APP_ERROR.NO_DATA:
            this.totalCntStr = '0';
            $state.complete();
          default:
            $state.error();
        }
        e === CONSTANTS.APP_ERROR.NO_DATA ? $state.complete() : $state.error();
      });
  }

  // LIFECYCLE HOOKS
  mounted() {
    this.UserStateModule.initialize({});
  }
}
